module.exports = __webpack_public_path__ + "img/transformdata-image6.a95cc217.png";